export type SignInStage = "verify_magic_link" | "sign_in_with_custom_token";

const STAGE_KEY = "signInStage";

/**
 * Marks which stage of completeEmailSignIn threw, by mutating the error
 * rather than wrapping it: FinishSignIn reads `err.code` and the message off
 * the original FirebaseError shape (its token-issue detection depends on
 * them), so a wrapper Error would break the existing handling.
 */
export function markSignInStage(error: unknown, stage: SignInStage): unknown {
  if (error && typeof error === "object") {
    (error as Record<string, unknown>)[STAGE_KEY] = stage;
  }
  return error;
}

export function getSignInStage(error: unknown): SignInStage | undefined {
  if (!error || typeof error !== "object") {
    return undefined;
  }
  const stage = (error as Record<string, unknown>)[STAGE_KEY];
  return stage === "verify_magic_link" || stage === "sign_in_with_custom_token"
    ? stage
    : undefined;
}
